import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const formularioAssociadoProcessoSlice = createSlice({
  name: 'formularioAssociadoProcesso',
  initialState,
  reducers: {
    carregarFormularioAssociadoProcesso: (state, action) => {
      const { idProcesso, formulario } = action.payload;
      state[idProcesso] = formulario;
    },
    limparFormularioAssociadoProcesso: (state, action) => {
      delete state[action.payload];
    },
  },
});

export const {
  carregarFormularioAssociadoProcesso,
  limparFormularioAssociadoProcesso,
} = formularioAssociadoProcessoSlice.actions;

export default formularioAssociadoProcessoSlice.reducer;
